/* ONNI Flashday (Ada 13.08.2026, Auftrag Paavo)
   Zeitlich begrenzte Aktion auf das ganze Sortiment, OHNE dass der Kunde einen Code
   eintippen muss.

   Aufgabenteilung, bewusst getrennt:
     Geld    -> automatischer Rabatt in Shopify, geplant auf dasselbe Zeitfenster.
                Nur der zaehlt im Warenkorb und im Checkout, und nur Shopify entscheidet
                darueber. Diese Datei kann keine Preise wirklich senken.
     Anzeige -> diese Datei. Sie setzt waehrend des Fensters den vorhandenen
                VIP-Mechanismus (discount.js) auf einen internen Code und schaltet
                Balken, Countdown und Begruessungsfenster frei.

   Warum ueber den vorhandenen Code-Mechanismus statt ueber eine zweite Preislogik:
   discount.js rechnet Karten, Collection, PDP, Sets und Grundpreis seit Monaten
   korrekt durch. Eine parallele Rechenstrecke waere eine zweite Fehlerquelle.

   Der interne Code wird NICHT kommuniziert und muss in Shopify auch nicht existieren.
   Er ist nur der Schluessel, mit dem die Anzeige weiss, welcher Satz gilt.

   Reihenfolge: diese Datei laeuft VOR discount.js (beide defer, im Dokument frueher),
   damit das Cookie steht, bevor discount.js es liest. Die Oberflaeche wird dagegen
   erst nach DOMContentLoaded gebaut, also garantiert nach discount.js.
*/
(function () {
  'use strict';

  var F = window.ONNI_FLASH;
  if (!F || !F.on) { return; }

  var COOKIE = 'discount_code';
  var MERKER = 'onni_code_vor_flash';   // vorheriger VIP-Code, wird danach zurueckgegeben
  var SKEW = 'onni_flash_skew';         // Abweichung Serverzeit minus Browseruhr, in ms
  var GESEHEN = 'onni_flash_popup';     // Begruessungsfenster nur einmal je Sitzung
  var NEULADEN = 'onni_flash_reload';   // Schutz gegen Nachlade-Schleife
  var WK_GESETZT = 'onni_flash_cart';   // Rabattcode wurde in dieser Sitzung auf den Warenkorb gelegt
  var WK_RELOAD = 'onni_flash_cart_rl'; // einmaliges Nachladen, wenn der Warenkorb schon gefuellt war

  /* ---------- Zeit ---------------------------------------------------------

     Die Zeiten stehen als "2026-08-14 18:00" in den Theme-Einstellungen und sind
     IMMER Shop-Zeit. Den passenden UTC-Versatz liefert Liquid mit ('now' | date: '%z'),
     damit Sommer- und Winterzeit nicht von Hand gepflegt werden muessen.

     Gerechnet wird gegen die SERVERZEIT, nicht gegen die Uhr des Besuchers. Eine
     falsch gestellte Uhr wuerde sonst reduzierte Preise zeigen, die der Checkout
     nicht gewaehrt. Die Abweichung wird einmal je Sitzung gemessen und gemerkt,
     danach ist die Entscheidung ohne Wartezeit da.
  */
  function zeit(text) {
    if (!text) { return NaN; }
    var t = String(text).trim().replace(' ', 'T');
    if (t.length === 16) { t += ':00'; }
    var tz = String(F.tz || '+0000').replace(/^([+-]\d{2})(\d{2})$/, '$1:$2');
    return Date.parse(t + tz);
  }

  var start = zeit(F.start);
  var ende = zeit(F.end);
  if (!isFinite(start) || !isFinite(ende) || ende <= start) { return; }

  /* Zwischenziel fuer den Countdown (Paavo 14.08.2026).
     Die Aktion laeuft in Wahrheit bis `ende`, der Countdown zeigt aber zuerst nur
     bis `zwischenziel`. Ist dieser Zeitpunkt erreicht, springt die Anzeige von
     selbst auf das echte Ende weiter und die Aktion wirkt verlaengert.
     Ohne Einstellung oder mit einem Wert ausserhalb des Fensters passiert nichts,
     dann zaehlt der Countdown wie bisher direkt auf `ende`. */
  var zwischenziel = F.end_stufe1 ? zeit(F.end_stufe1) : NaN;
  if (!isFinite(zwischenziel) || zwischenziel <= start || zwischenziel >= ende) {
    zwischenziel = null;
  }
  function anzeigeEnde() {
    if (zwischenziel && jetzt() < zwischenziel) { return zwischenziel; }
    return ende;
  }

  function versatz() {
    var v = parseInt(sessionStorage.getItem(SKEW) || '0', 10);
    return isFinite(v) ? v : 0;
  }
  function jetzt() { return Date.now() + versatz(); }

  /* Vorschau fuer Tests: ?flashday=preview schaltet die Aktion unabhaengig von der
     Uhrzeit ein und haelt sie fuer die Sitzung, ?flashday=off schaltet sie wieder aus.

     Bewusst gesperrt auf Themevorschau und Customizer. Sonst koennte jeder auf der
     Live-Seite reduzierte Preise einblenden, die der Checkout nicht gewaehrt.
     Geprueft wird die Themerolle, nicht der URL-Parameter: Shopify leitet beim
     Vorschau-Aufruf einmal um und wirft preview_theme_id dabei aus der Adresse. */
  var rolle = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
  var darfVorschau = !!(window.Shopify && window.Shopify.designMode) ||
                     (rolle !== '' && rolle !== 'main');
  var param = new URLSearchParams(location.search).get('flashday');
  if (param === 'preview' && darfVorschau) { sessionStorage.setItem('onni_flash_preview', '1'); }
  if (param === 'off') { sessionStorage.removeItem('onni_flash_preview'); }
  var vorschau = sessionStorage.getItem('onni_flash_preview') === '1';

  function aktiv() {
    if (vorschau) { return true; }
    var n = jetzt();
    return n >= start && n < ende;
  }

  /* ---------- Cookie ------------------------------------------------------- */

  function lies(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }
  function schreib(name, wert, sekunden) {
    document.cookie = name + '=' + wert + '; path=/; max-age=' + sekunden;
  }

  function anschalten() {
    var vorher = lies(COOKIE);
    // Einen echten VIP-Code des Besuchers nicht verlieren: er wird gemerkt und nach
    // der Aktion zurueckgegeben. Waehrend der Aktion gilt der Flashday, weil die
    // Rabatte laut Vorgabe nicht stapelbar sind.
    if (vorher && vorher !== F.code) {
      try { localStorage.setItem(MERKER, vorher); } catch (e) {}
    }
    schreib(COOKIE, F.code, 7200);
    document.documentElement.setAttribute('data-onni-flash', '1');
    // Platz fuer den Balken frueh reservieren, sonst springt die Seite (siehe theme.liquid)
    document.documentElement.classList.add('onni-has-vipbar');
  }

  function ausschalten() {
    // Code-Review A-01: discount.js hatte den Flash-Code frueher 7 Tage in sein eigenes
    // Anzeige-Cookie uebernommen. Das wird hier mit abgeraeumt.
    if (lies('onni_vip_code') === F.code) { schreib('onni_vip_code', '', 0); }
    if (lies(COOKIE) !== F.code) { return false; }
    schreib(COOKIE, '', 0);
    var alt = '';
    try { alt = localStorage.getItem(MERKER) || ''; } catch (e) {}
    if (alt) {
      schreib(COOKIE, alt, 604800);
      try { localStorage.removeItem(MERKER); } catch (e) {}
    }
    document.documentElement.removeAttribute('data-onni-flash');
    return true;
  }

  /* ---------- Rabattcode auf den Warenkorb legen ---------------------------

     Paavo 13.08.2026: Der Nachlass soll die ganze Zeit im Warenkorb stehen und
     nicht erst im Checkout auftauchen. Deshalb legen wir den echten Shopify-Code
     einmal je Sitzung still auf den Warenkorb (POST /cart/update.js). Gemessen:
     der Code haftet auch am LEEREN Warenkorb und gilt fuer alles, was danach
     hineingelegt wird — ein Aufruf reicht also fuer den ganzen Besuch.

     War der Warenkorb schon gefuellt, ist das serverseitig gerenderte HTML in
     dem Moment veraltet. Dann wird genau einmal nachgeladen; bei leerem
     Warenkorb, also im Regelfall, passiert nichts dergleichen. */
  function warenkorb(code, beiFertig) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) { return r.json(); }).then(beiFertig).catch(function () {});
  }

  function warenkorbAnschalten() {
    if (!F.cart_code || sessionStorage.getItem(WK_GESETZT)) { return; }
    warenkorb(F.cart_code, function (c) {
      sessionStorage.setItem(WK_GESETZT, '1');
      if (c && c.item_count > 0 && !sessionStorage.getItem(WK_RELOAD)) {
        sessionStorage.setItem(WK_RELOAD, '1');
        location.reload();
      }
    });
  }

  function warenkorbAusschalten() {
    if (!sessionStorage.getItem(WK_GESETZT)) { return; }
    sessionStorage.removeItem(WK_GESETZT);
    warenkorb('', function () {});
  }

  var war_aktiv = aktiv();
  /* 19.10.2026 Ada (Johannes, Code-Review A-01): discount.js meldet den Flash-Code nur an,
     wenn das Fenster jetzt wirklich laeuft. Der Schalter allein reicht nicht mehr, sonst
     zeigt der alte Link #onni-flashday nach Aktionsende weiter Rabattpreise. */
  F.aktiv = war_aktiv;
  if (war_aktiv) {
    anschalten();
    warenkorbAnschalten();
  } else {
    ausschalten();
    warenkorbAusschalten();
  }

  /* ---------- Serverzeit nachmessen ----------------------------------------

     /cart.js ist klein und wird nicht zwischengespeichert, der Date-Kopf ist damit
     die echte Serverzeit. Weicht die Entscheidung danach ab, wird die Seite genau
     einmal neu geladen, statt eine halb falsche Anzeige stehen zu lassen.
  */
  if (!sessionStorage.getItem(SKEW)) {
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) {
      var d = r.headers.get('date');
      if (!d) { return; }
      var server = Date.parse(d);
      if (!isFinite(server)) { return; }
      sessionStorage.setItem(SKEW, String(server - Date.now()));
      if (aktiv() !== war_aktiv && !sessionStorage.getItem(NEULADEN)) {
        sessionStorage.setItem(NEULADEN, '1');
        location.reload();
      }
    }).catch(function () {});
  }

  if (!aktiv()) { return; }

  /* ---------- Oberflaeche --------------------------------------------------- */

  function zweistellig(n) { return (n < 10 ? '0' : '') + n; }

  /* In der Vorschau liegt das Fenster meist in der Zukunft. Dann waere der Countdown
     eine Tagesangabe und der Screenshot unbrauchbar, deshalb wird die volle Dauer
     ab jetzt gezeigt. Im Echtbetrieb aendert das nichts. */
  var schieben = (vorschau && jetzt() < start) ? (jetzt() - start) : 0;

  function restText() {
    var rest = Math.max(0, anzeigeEnde() + schieben - jetzt());
    var s = Math.floor(rest / 1000);
    return zweistellig(Math.floor(s / 3600)) + ':' +
           zweistellig(Math.floor(s / 60) % 60) + ':' +
           zweistellig(s % 60);
  }

  function uhrenStellen() {
    var txt = restText();
    document.querySelectorAll('[data-flash-clock]').forEach(function (el) {
      el.textContent = txt;
    });
    // Laeuft die Aktion waehrend des Besuchs aus, muss die Anzeige weg. Ein Neuladen
    // ist hier der ehrlichste Weg: danach steht ueberall wieder der normale Preis.
    if (!vorschau && jetzt() >= ende) {
      ausschalten();
      warenkorbAusschalten();
      location.reload();
    }
  }

  /* Paavo 14.08.2026: immer "mind. -25% auf alles", klein geschrieben, ohne
     Leerzeichen vor dem Prozent und mit Minus davor. Das "mind." ist wichtig, weil
     bereits reduzierte Sets mehr als den Aktionssatz sparen. Kein "min." — das
     steht fuer Minute und waere neben einem Countdown missverstaendlich. */
  function prozentText() {
    return 'mind. -' + F.percent + '%';
  }

  /* Shopifys eigener Rabatt-Einstieg: /discount/CODE?redirect=... legt den Code auf
     die Sitzung und leitet danach weiter. Das ist der sicherste Weg, den Rabatt an
     den Kunden zu binden, auch wenn unser stilles Setzen im Warenkorb einmal nicht
     durchkommt. (Paavo 14.08.2026) */
  function aktionsZiel() {
    var ziel = F.cta_url || '/collections/produkte';
    if (!F.cart_code) { return ziel; }
    return '/discount/' + encodeURIComponent(F.cart_code) +
           '?redirect=' + encodeURIComponent(ziel);
  }

  function balken() {
    var bar = document.getElementById('discountbar');
    if (!bar) { return; }
    // discount.js hat hier den VIP-Text hineingeschrieben. Beim Flashday gibt es
    // keinen Code zum Vorzeigen, also ersetzen wir ihn durch die Aktionszeile.
    bar.innerHTML =
      '<a class="onni-flash-bar" href="' + aktionsZiel() + '">' +
        '<b class="onni-flash-bar__title">' + F.title + '</b>' +
        '<span class="onni-flash-bar__pct">' + prozentText() + ' auf alles</span>' +
        '<span class="onni-flash-bar__hint">' + (F.claim ? F.claim + ', ' : '') + 'ohne Code</span>' +
        '<span class="onni-flash-bar__clock" data-flash-clock>' + restText() + '</span>' +
      '</a>';
    bar.classList.add('discountbar--flash');
    bar.style.display = 'block';
  }

  function fensterBauen() {
    if (!F.popup) { return; }
    if (sessionStorage.getItem(GESEHEN)) { return; }

    var wrap = document.createElement('div');
    wrap.className = 'onni-flash-modal';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'onni-flash-h');
    wrap.innerHTML =
      '<div class="onni-flash-modal__box" tabindex="-1">' +
        '<button type="button" class="onni-flash-modal__x" aria-label="Schließen">&times;</button>' +
        '<p class="onni-flash-modal__kicker">' + F.window_label + '</p>' +
        '<h2 class="onni-flash-modal__h" id="onni-flash-h">' + F.title + '</h2>' +
        '<p class="onni-flash-modal__pct">' + prozentText() + ' auf alles</p>' +
        (F.claim ? '<p class="onni-flash-modal__claim">' + F.claim + '</p>' : '') +
        '<p class="onni-flash-modal__clock"><span class="onni-flash-modal__clocklbl">endet in</span> ' +
          '<b data-flash-clock>' + restText() + '</b></p>' +
        '<p class="onni-flash-modal__note">' + F.note + '</p>' +
        '<a class="button onni-flash-modal__cta" href="' + aktionsZiel() + '">' + F.cta + '</a>' +
      '</div>';

    function zu() {
      sessionStorage.setItem(GESEHEN, '1');
      wrap.classList.remove('is-open');
      setTimeout(function () { wrap.remove(); }, 200);
      document.removeEventListener('keydown', beiTaste);
    }
    function beiTaste(e) { if (e.key === 'Escape') { zu(); } }

    wrap.addEventListener('click', function (e) {
      // Klick daneben schliesst (ONNI-Drawer-Standard, Paavo 23.07.2026)
      if (e.target === wrap ||
          e.target.closest('.onni-flash-modal__x') ||
          e.target.closest('.onni-flash-modal__cta')) { zu(); }
    });
    document.addEventListener('keydown', beiTaste);

    document.body.appendChild(wrap);
    requestAnimationFrame(function () { wrap.classList.add('is-open'); });
    // Fokus auf den Kasten, nicht auf das Kreuz: sonst liegt der Fokusrahmen
    // sichtbar um das X, obwohl niemand mit der Tastatur navigiert hat.
    var box = wrap.querySelector('.onni-flash-modal__box');
    if (box) { box.focus(); }
  }

  /* Der Consent-Dialog hat Vorrang. Erst wenn er weg ist, kommt das Aktionsfenster,
     sonst liegen zwei Ebenen uebereinander und der Kunde klickt die falsche weg. */
  function fensterZeigen(versuche) {
    // offsetParent taugt hier NICHT: der Consent-Dialog liegt position:fixed, dann ist
    // offsetParent auch im sichtbaren Zustand null. Gemessen wird deshalb die Flaeche.
    var consent = document.querySelector('#pandectes-banner, .pd-cookie-banner-window, .cc-window');
    var sichtbar = false;
    if (consent) {
      var stil = getComputedStyle(consent);
      sichtbar = stil.display !== 'none' && stil.visibility !== 'hidden' &&
                 consent.getBoundingClientRect().height > 0;
    }
    if (sichtbar && versuche < 30) {
      setTimeout(function () { fensterZeigen(versuche + 1); }, 1000);
      return;
    }
    fensterBauen();
  }

  /* Das kleine x neben der Rabattzeile im Warenkorb wuerde den Flashday entfernen.
     Ein Fehlklick koennte den Kunden den ganzen Aktionsrabatt kosten, und wieder anlegen wuerden wir ihn
     in dieser Sitzung nicht. Also nur fuer UNSEREN Code ausblenden, fremde Codes
     bleiben abwaehlbar. */
  function xVerstecken() {
    if (!F.cart_code) { return; }
    if (document.getElementById('onni-flash-style')) { return; }
    var st = document.createElement('style');
    st.id = 'onni-flash-style';
    var code = String(F.cart_code).replace(/["\\]/g, '');
    st.textContent = '.cart-discounts__item[data-discount-code="' + code + '" i] .onni-rabatt-weg' +
                     '{display:none !important;}';
    document.head.appendChild(st);
  }

  function start_ui() {
    balken();
    xVerstecken();
    setInterval(uhrenStellen, 1000);
    setTimeout(function () { fensterZeigen(0); }, F.popup_delay || 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start_ui);
  } else {
    start_ui();
  }
})();
